module.exports = __webpack_public_path__ + "static/media/77-hair.13633c65.jpg";